'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auth = require('./auth.component');

var _auth2 = _interopRequireDefault(_auth);

var _forgotPassword = require('./forgot-password/forgot-password.module');

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _login = require('./login/login.module');

var _login2 = _interopRequireDefault(_login);

var _resetPassword = require('./reset-password/reset-password.module');

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _resetPasswordFrompin = require('./reset-password-frompin/reset-password-frompin.module');

var _resetPasswordFrompin2 = _interopRequireDefault(_resetPasswordFrompin);

require('./auth.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.auth', [_angularUiRouter2.default, _forgotPassword2.default, _login2.default, _resetPassword2.default, _resetPasswordFrompin2.default]).component('auth', _auth2.default).config(function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('auth', {
    url: '/auth',
    component: 'auth',
    resolve: {
      layout: function layout() {
        return 'column';
      },
      flex: function flex() {
        return '100';
      }
    }
  });

  $urlRouterProvider.otherwise('/auth/login');
}).name;


// WEBPACK FOOTER //
// ./components/auth/auth.module.js